<img src="lumsa-logo-white.png" alt="Lumsa Logo" [style.width]="width()" [style.height]="height()" />
